import { UseFormReturn } from 'react-hook-form'

import { Alert } from '@tribeplatform/react-ui-kit/Alert'

import { T } from '../../i18n/index.js'

import { usePollFormContext } from './PollFormContext.js'
import { PollFormOptions } from './PollFormOptions.js'
import { PollFormTitle } from './PollFormTitle.js'
import { PollFormValues } from './types.js'

export interface PollFormBodyProps {
  form: UseFormReturn<PollFormValues>
}

export function PollFormBody({ form }: PollFormBodyProps) {
  const { hasAlreadyVoted } = usePollFormContext()
  return (
    <div className="space-y-6">
      {hasAlreadyVoted && (
        <Alert status="info">
          <T
            id="Poll.Form.Details.LiveNotAllowed"
            defaultMessage="Some users have already participated in this poll. You can no longer change the details or add new choices."
          />
        </Alert>
      )}
      <PollFormTitle disabled={hasAlreadyVoted} />
      <PollFormOptions form={form} disabled={hasAlreadyVoted} />
    </div>
  )
}
